import * as React from 'react';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { constants } from '../../constants';

interface ComponentProps {
    strong?: boolean;
    breakPoint1?: number;
    light?: boolean;
    color?: string;
    dark?: boolean;
    altColor?: boolean;
    style?: string;
    onClick?: () => void;
    children: ReactNode;
}

const fontSize = constants.text.baseFontStyles.fontSize;
const StyledP = styled<ComponentProps, 'p'>('p')`
    display: flex;
    flex-flow: column nowrap;
    line-height: 1.6em;
    font-size: ${fontSize}px;
    font-weight: ${props => (props.strong ? 500 : 400)};
    letter-spacing: ${props => (props.light ? '0.02em' : 0)};
    font-family: ${constants.text.baseFontStyles.fontFamily};
    color: ${props => props.textColor};
    margin: ${fontSize}px 0 ${fontSize * 1.2}px 0;
    box-sizing: border-box;
    @media (max-width: ${props =>
            props.breakPoint1 ? props.breakPoint1 : '0'}px) {
    }
`;

const PText: React.StatelessComponent<ComponentProps> = ({
    color,
    dark = false,
    light = false,
    altColor = false,
    style,
    onClick,
    children,
    ...rest
}) => {
    let textColor = '';

    if (color) {
        textColor = color;
    } else if (altColor) {
        textColor = constants.color.grey34;
    } else if (dark) {
        textColor = constants.color.dark;
    } else if (light) {
        textColor = constants.color.light;
    } else {
        textColor = constants.color.grey75;
    }

    return (
        <StyledP
            style={style}
            textColor={textColor}
            light={light}
            onClick={onClick}
            {...rest}
        >
            {children}
        </StyledP>
    );
};

export default PText;



// WEBPACK FOOTER //
// ./src/js/components/Primatives/PText.tsx